import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("compte_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des SpecificationItem
export const listeDesSpecification = async (page, size, param) => {
  // return await axios.get(`${BASE_URL}/parametrage/allCategorie`), {});
  return await axios.get(
    `${BASE_URL}/parametrage/specification?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

// /liste SpecificationItem sans filters
export const listeSpecificationSansFiltre = async () => {
  // return await axios.get(`${BASE_URL}/parametrage/allCategorie`), {});
  return await axios.get(`${BASE_URL}/parametrage/specification/allSpecification`, {});
};

// Enregiste des SpecificationItem
export const enregistrerSpecification = async (dataSpecification) => {
  return await axios.post(`${BASE_URL}/parametrage/Specification`, dataSpecification);
};

// modifie Specifications  
export const modifierSpecificationById = async (specificationId, dataSpecification) => {
  return await axios.put(
    `${BASE_URL}/parametrage/specification/${specificationId}`,
    dataSpecification
  );
};

// supprimer une Specifications
export const supprimerSpecificationById = async (specificationId) => {
  return await axios.delete(`${BASE_URL}/parametrage/specification/${specificationId}`);
};
